import { Badge, Stack } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { DetailSection, LabelText } from '../../../../../../../components/generic';
import { Course } from '../../../../../../../types/course.type';
import { formatToCurrency } from '../../../../../../../utils/utils';

interface Props {
  course: Course | undefined;
}

export const SessionInvoicesSection = ({ course }: Props) => (
  <DetailSection title="Invoices">
    <LabelText
      label="Amount Receivable:"
      text={`${formatToCurrency(course?.amount_receivable ?? 0)}`}
    />
    <LabelText
      label="Amount Invoiced:"
      text={`${formatToCurrency(course?.amount_invoiced ?? 0)}`}
    />
    <LabelText
      label="Difference:"
      text={`${formatToCurrency(
        (course?.amount_receivable ?? 0) - (course?.amount_invoiced ?? 0)
      )}`}
    />
    {!course?.invoices?.length ? (
      <span
        style={{ background: '#6098B8', color: '#FFFFFF', fontSize: '.75rem' }}
        className="rounded-4 fw-semibold px-2 py-1"
      >
        There are no invoices to show
      </span>
    ) : (
      <Stack
        direction="vertical"
        gap={1}
      >
        {course?.invoice_statuses.map((invoice) => (
          <Link
            key={invoice?.id}
            to={`/admin/finance/invoices/${invoice?.id}`}
            className="text-info bullet-link"
          >
            {invoice?.name}
            {invoice?.status === 'late' && (
              <Badge
                bg="#CE4D2D"
                style={{ backgroundColor: '#CE4D2D' }}
                className="ms-2 p-1"
              >
                <span style={{ color: 'white', fontSize: '0.85rem' }}>Late</span>
              </Badge>
            )}
            {invoice?.status === 'paid' && (
              <Badge
                bg="#BFC662"
                style={{ backgroundColor: '#BFC662' }}
                className="ms-2 p-1"
              >
                <span style={{ color: 'white', fontSize: '0.875rem' }}>Paid</span>
              </Badge>
            )}
            {invoice?.status === 'draft' && (
              <Badge
                bg="#7F9BB4"
                style={{ backgroundColor: '#7F9BB4' }}
                className="ms-2 p-1"
              >
                <span style={{ color: 'white', fontSize: '0.875rem' }}>Draft</span>
              </Badge>
            )}
            {invoice?.status === 'sent' && (
              <Badge
                bg="#953E6A"
                style={{ backgroundColor: '#953E6A' }}
                className="ms-2 p-1"
              >
                <span style={{ color: 'white', fontSize: '0.875rem' }}>Sent</span>
              </Badge>
            )}
          </Link>
        ))}
      </Stack>
    )}
  </DetailSection>
);
